
import React, { useEffect, useState } from "react";

import { RefreshCcw } from "lucide-react";
import axios from "axios";

const Captcha = ( props ) => {
  const [captchaImage, setCaptchaImage] = useState("");

    const fetchCaptcha = async () => {
    try {
       const timestamp = new Date().getTime();
      const response = await axios.get( `${process.env.REACT_APP_URL}/auth/captcha-image?t=${timestamp}`); 
      const { image, salt } = response.data;

      setCaptchaImage(`data:image/jpeg;base64,${image}`);
      props.onSaltChange(salt);
    } catch (error) {
      console.error('Failed to fetch captcha:', error);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, [props.reCaptcha]);

  return (
    <div className="form-group1">
      <div className="captcha-wrapper">
        {/* Use the dynamically set captcha URL  */}
         {captchaImage && <img src={captchaImage} height="40px" alt="captcha" id="captchaImage" />}
        {/* <img src={captchaImage} height="40px" alt="captcha" id="captchaImage" /> */}
        <div
          id="captchaRefreshIcon"
          className="captcha-regen-icon"
          onClick={fetchCaptcha}
        >
           <RefreshCcw color="#B8001F" />
        </div>
        
      </div>
      
    </div>
  );
};

export default Captcha;